import { createApp } from 'vue';
import App from './TheApp.vue';

const app = createApp(App);

app.mount('#app');
